import { useMemo, useEffect, useState } from 'react';
import { Box, Button, Icon, LinearProgress, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, useTheme, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from "react-router-dom"

import { IPerfil, PerfilService } from '../../shared/services/api/perfil/PerfilService';
import { AlertSnackBar, AutoCompleteDeCliente, FerramentasDaListagem } from "../../shared/components"
import { LayoutBaseDePagina } from "../../shared/layouts"
import { Environment } from '../../shared/environment';
import { IPaginacao } from '../../shared/services/api/axios-config';
import { DialogConfirm } from '../../shared/components/dialog/DialogConfirm';

export const ListagemDePerfilDesativado: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const theme = useTheme();

  const [cnpj, setCnpj] = useState<string | undefined | null>(undefined);

  const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  const [rows, setRows] = useState<IPerfil[]>([]);
  const [paginacao, setPaginacao] = useState<IPaginacao>({
    totalCount: 0,
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false
  });
  const [isLoading, setIsLoading] = useState(false);

  function resetPaginacao() {
    setPaginacao({
      totalCount: 0,
      pageSize: 0,
      currentPage: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false
    });
  }

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  useEffect(() => {
    handleNewSearch(false);
  }, [cnpj])

  useEffect(() => {
    handleNewSearch(true);
  }, [pagina])

  const handleNewSearch = (newPage: boolean) => {
    if (cnpj === undefined || cnpj === null || cnpj == '') {
      setRows([]);
      resetPaginacao();
    } else {

      setRows([]);
      resetPaginacao();
      setIsLoading(true);

      if (newPage) {

        PerfilService.getAllByCnpj(cnpj, pagina, false).then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {//verificar se deu erro
            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);
          }
          else {
            setPaginacao(result.paginacao);
            setRows(result.perfis);
          }
        });
      } else {

        setSearchParams({ pagina: "1" }, { replace: true })

        PerfilService.getAllByCnpj(cnpj, 1, false).then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {//verificar se deu erro
            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);
          }
          else {
            setPaginacao(result.paginacao);
            setRows(result.perfis);
          }
        });
      }
    }
  }


  const handleReable = () => {
    setAbrir(false);
    setIsLoading(true);
    PerfilService.toggleEnabledById(idToReable).then(result => {
      setIsLoading(false);
      if (result instanceof Error) {//verificar se deu erro
        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
        setTimeout(() => {
          setAlertSnackbar(undefined);
        }, duracaoAlert);
      } else {
        setRows(oldRows => {
          return [
            ...oldRows.filter(oldRow => oldRow.idPerfil !== idToReable),
          ]
        });
        setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Perfil reativado" });
        setTimeout(() => {
          setAlertSnackbar(undefined);
        }, duracaoAlert);
      }
    });
  }

  const [abrir, setAbrir] = useState(false);
  const [idToReable, setidToReable] = useState<number>(0);

  const handleClickReable = (idUnidade: number) => {
    setAbrir(true);
    setidToReable(idUnidade);
  };

  const handleCancel = () => {
    setAbrir(false);
  };

  return (
    <LayoutBaseDePagina
      titulo="Listagem de perfis desativados"
      barraDeFerramentas={
        <Box
          component={Paper}
          height={theme.spacing(5)}
          marginX={1}
          padding={1}
          paddingX={2}
          display="flex"
          gap={1}
          alignItems="center"
        >
          <AutoCompleteDeCliente selectedCnpj={selectedCnpj => setCnpj(selectedCnpj)} />

          <Box flex={1} display="flex" justifyContent="end">
            <Box width={5}></Box>
            <Button
              color="primary"
              disableElevation
              variant="contained"
              endIcon={<Icon>add</Icon>}
              onClick={() => navigate('/perfil/detalhe/novo')}
            >
              Novo
            </Button>
          </Box>
        </Box>
      }
    >
      {alertSnackbar !== undefined && (
        <>
          {alertSnackbar.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alertSnackbar.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alertSnackbar.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}

      <DialogConfirm
        AoConfirmar={handleReable}
        titulo={"Dejesa realmente reativar o setor?"}
        texto={"Ao confirmar, o perfil e suas permissões será reativado."}
        abrir={abrir}
        AoCancelar={handleCancel}
      />

      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>

              <TableCell> Nome </TableCell>
              <TableCell> Permissões </TableCell>
              <TableCell> Ações </TableCell>

            </TableRow>
          </TableHead>
          <TableBody>

            {rows.map(row => (
              <TableRow key={row.idPerfil}>
                <TableCell> {row.nomePerfil} </TableCell>
                <TableCell>
                  {row.abrir && ("Abrir")}
                  {row.alterar && (" | Alterar")}
                  {row.excluir && (" | Excluir")}
                  {row.mesclar && (" | Mesclar")}
                  {row.indexar && (" | Indexar")}
                  {/* {row.consultarDesativado && (" | Consultar desativado")} */}
                </TableCell>
                <TableCell>
                  <Button
                    color="primary"
                    disableElevation
                    variant="contained"
                    onClick={() => handleClickReable(row.idPerfil)}
                  >
                    Reativar
                  </Button>
                </TableCell>
              </TableRow>
            ))}

          </TableBody>

          {paginacao.totalCount === 0 && !isLoading && cnpj !== undefined && cnpj !== null && cnpj != '' && (
            <caption> {Environment.LISTAGEM_VAZIA} </caption>
          )}
          {cnpj === undefined || cnpj === null || cnpj == '' && !isLoading && (
            <caption> Selecione uma empresa para pesquisar </caption>
          )}

          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={5}>{/* quantas colunas o loading vai ocupar */}
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {(paginacao?.totalPages > 1 && !isLoading) && (
              <TableRow>
                <TableCell colSpan={5} align="right">
                  <Box flexDirection="row" display="inline-flex">
                    <Typography noWrap marginTop={0.5} >Exibindo {paginacao.hasNext ? paginacao.pageSize * paginacao.currentPage : paginacao.totalCount} de {paginacao?.totalCount}</Typography>
                    <Pagination
                      page={pagina}
                      count={paginacao?.totalPages}
                      onChange={(_, newPage) => setSearchParams({ pagina: newPage.toString() }, { replace: true })}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
    </LayoutBaseDePagina >
  )
}